export default __webpack_public_path__ + "static/media/correct11.8a025132.mp3";